import type {RequestOptions} from '$types/request-response';

type BuildRequestUrl = (
  endpoint: string,
  parameters?: RequestOptions['parameters'],
  query?: RequestOptions['query'],
) => string;

const buildRequestUrl: BuildRequestUrl = (endpoint, parameters, query) => {
  const parameterisedUrl = endpoint
    .split('/')
    .map((pathPart) => {
      const isParameter = pathPart.startsWith(':');

      return isParameter && parameters
        ? parameters[pathPart.replace(':', '')]
        : pathPart;
    })
    .join('/');
  const url = new URL(parameterisedUrl);

  if (query) {
    Object.keys(query || {}).map((key) =>
      url.searchParams.set(key, query[key]),
    );
  }
  const urlString = query
    ? [url.toString(), query.toString()].join('?')
    : url.toString();

  return urlString;
};

export {buildRequestUrl};
